const triggerCustomEvent = (eventData, eventName) => {
  const event = new CustomEvent(eventName, {
    detail: eventData,
  });
  document.dispatchEvent(event);
};

const setSessionVar = (varName, data) => {
  // Save data to sessionStorage
  sessionStorage.setItem(varName, JSON.stringify(data));
};

const removeSessionVar = (varName) => {
  sessionStorage.removeItem(varName);
};

const getSessionVar = (varName) => {
  try {
    const data = sessionStorage.getItem(varName);
    return JSON.parse(data) || {};
  } catch (err) {
    return {};
  }
};

async function sha256(message) {
	// encode as UTF-8
	const msgBuffer = new TextEncoder().encode(message);

	// hash the message
	const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

	// convert ArrayBuffer to Array
	const hashArray = Array.from(new Uint8Array(hashBuffer));

	// convert bytes to hex string                  
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
	return hashHex;
}

async function toEhashAsync(email) {
	if (!email || typeof email !== "string") {
		return Promise.resolve("");
	}

	return sha256(email.toLowerCase());
}

export { triggerCustomEvent, setSessionVar, removeSessionVar, getSessionVar, toEhashAsync };
